import { HomePage } from "./../home/home";
import { ViewHeaderPage } from "./../view-header/view-header";
import { PlazaSelectPlanPage } from "./../plaza-select-plan/plaza-select-plan";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { PlazaTicketSocialPage } from "./../plaza-ticket-social/plaza-ticket-social";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-plaza-ticket",
  templateUrl: "plaza-ticket.html",
})
export class PlazaTicketPage {
  space: any;
  bgImage = "";
  round = 1;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    public alertCtrl: AlertController,
    private loadingCtrl: LoadingController
  ) {
    this.space = this.navParams.data.space;
    this.bgImage =
      "assets/bg/social/" + this.space.socialShop.social_shop_id + ".jpg";
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("roundGame").then((round) => {
      this.round = round;
    });
  }

  addTicket(space) {
    this.navCtrl.push(PlazaTicketSocialPage, { space: space });
  }

  removeTicket(space_no) {
    const confirm = this.alertCtrl.create({
      // title: 'Remove this shop?',
      message: "You want remove this shop?",
      buttons: [
        {
          text: "Yes",
          handler: () => {
            const loader = this.loadingCtrl.create({
              content: "Loading...",
            });
            loader.present();
            this.storage.get("token").then((token) => {
              var link = this.services.URLTicketRemove + space_no;
              var headers = new Headers();
              headers.append("Accept", "application/json");
              headers.append("Authorization", "Bearer " + token);
              const requestOptions = new RequestOptions({ headers: headers });

              this.http
                .delete(link, requestOptions)
                .map((res) => res.json())
                .subscribe(
                  (data) => {
                    loader.dismiss();
                    this.navCtrl.push(PlazaSelectPlanPage);
                  },
                  (error) => {
                    var response = JSON.parse(error._body);
                    loader.dismiss();
                    this.translateService
                      .get(response.message)
                      .subscribe((value) => {
                        this.services.presentToast(value);
                      });
                  }
                );
            });
          },
        },
        {
          text: "No",
          cssClass: "btn-no",
          handler: () => {
            // console.log('Disagree clicked');
          },
        },
      ],
    });
    confirm.present();
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-ticket/plaza-ticket.ts